import { render, staticRenderFns } from "./SettingMessageTemplateRegister.vue?vue&type=template&id=a2378754"
import script from "./SettingMessageTemplateRegister.vue?vue&type=script&lang=js"
export * from "./SettingMessageTemplateRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports